import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../contexts/I18nContext';
import './CreationRecord.scss';
import CreationRecordView from './CreationRecordView';
import useCreationRecordActions from './useCreationRecordActions';
import useCreationRecordData from './useCreationRecordData';
import { getTypeDisplayName } from './creationRecordUtils';

const CreationRecord = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const { user } = useAuth();
  const [filter, setFilter] = React.useState('all');
  const { loading, loadRecords, loadStats, records, stats } = useCreationRecordData(filter);
  const typeLabel = useCallback((type) => getTypeDisplayName(type, t), [t]);
  const { handlers, modalProps, setVideoModalUrl } = useCreationRecordActions({ loadRecords, loadStats, t });
  const actions = { ...handlers, refresh: () => { loadRecords(); loadStats(); }, setVideoModalUrl };

  const filteredRecords = filter === 'all'
    ? records
    : records.filter((record) => record.status.toLowerCase() === filter);

  return (
    <CreationRecordView
      actions={actions}
      filteredRecords={filteredRecords}
      filter={filter}
      loading={loading}
      modalProps={modalProps}
      navigate={navigate}
      setFilter={setFilter}
      stats={stats}
      t={t}
      typeLabel={typeLabel}
      user={user}
    />
  );
};

export default CreationRecord;
